/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  UPDATE_AUTHENTICATED_USER(state, info) {
    localStorage.setItem("userInfo", JSON.stringify(info.userInfo));
    // localStorage.setItem('userRole', JSON.stringify(info.userInfo.roles_mask));
    let nameRole;
    if (info.userInfo.roles_mask == 1) {
      nameRole = "ROLE_SYSADMIN";
    } else if (info.userInfo.roles_mask == 16 || info.userInfo.roles_mask == 24) {
      nameRole = "ROLE_OBSERVE_EXCISE_TANKER";
    } else {
      nameRole = "ROLE_EDITOR";
    }
    console.log("roles_mask >>>>>>>>>>>>> ", info.userInfo, nameRole);
    // if (info.userInfo.roles_mask == 1) {
    //   nameRole = "ROLE_SYSADMIN"
    // } else if (info.userInfo.roles_mask == 2) {
    //   nameRole = "ROLE_ADMIN"
    // } else if (info.userInfo.roles_mask == 3) {
    //   nameRole = "ROLE_EDITOR"
    // } else {
    //   nameRole = "ROLE_VIEWER"
    // }
    localStorage.setItem("userRole", nameRole);
    state.userRole = nameRole;
    localStorage.setItem("accessEmail", info.userInfo.email);
    localStorage.setItem("accessToken", info.userInfo.authentication_token);
  }
  // UPDATE_AUTHENTICATED_USER_TOKEN(state, info) {
  //   localStorage.setItem('accessToken', info.userInfo.authentication_token);
  // },
  // UPDATE_USER_ROLE(state, val) {
  //   state.userRole = val
  //   localStorage.setItem('userRole', val)
  // },
};
